const BYTE = 1000;
const MEGABYTES_SCALE = 2;

export const getFileSize = (file: File) => {
    return file.size / (BYTE ** MEGABYTES_SCALE);
};
